(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["showcase-products"] && !Shopify.designMode) return;
  try {
    

  var showcase_div = $('.showcase-details');

  var showcase_background_default_class= "showcase_background_default";
  var showcase_background_classes = "showcase_background_default showcase_background_0 showcase_background_1 showcase_background_2 showcase_background_3 showcase_background_4 showcase_background_5";
  var showcase_background_classes_mobile = "showcase_background_6 showcase_background_7 showcase_background_8 showcase_background_9 showcase_background_10 showcase_background_11";

  var showcase_title_ele= $('#showcase-details-title');
  var showcase_title_ele_default_value = showcase_title_ele.text();

  var showcase_description_ele = $("#showcase-details-description");
  var showcase_description_ele_default_value = showcase_description_ele.text();

  function showDetails(event) {
    let showcase_product_title = $(event.target).attr('data-product-title');
    let showcase_product_descritpion = $(event.target).attr('data-product-description');

    let showcase_product_position = $(event.target).attr('data-product-pos');
    let cssClass = "showcase_background_" + showcase_product_position;

    showcase_div.removeClass(showcase_background_classes);
    showcase_div.removeClass(showcase_background_classes_mobile);
    showcase_div.addClass(cssClass);

    showcase_title_ele.text(showcase_product_title);
    showcase_description_ele.text(showcase_product_descritpion);
  }

  function showOriginal(event) {
    showcase_div.removeClass(showcase_background_classes);
    showcase_div.removeClass(showcase_background_classes_mobile);
    showcase_div.addClass(showcase_background_default_class);

    showcase_title_ele.text(showcase_title_ele_default_value);
    showcase_description_ele.text(showcase_description_ele_default_value);
  }

  var showcase_products = $(".showcase-product");

  for(var i = 0; i < showcase_products.length; i++)
  {
    showcase_products[i].addEventListener("mouseenter", showDetails);
    showcase_products[i].addEventListener("mouseleave", showOriginal);
  }
 

  } catch(e) { console.error(e); }
})();
})();
